document.addEventListener('DOMContentLoaded', function() {
    // swipers
    let swiperRelated = new Swiper('.swiper-related', {
        speed: 1000,
        spaceBetween: 32,
        loop: true,
        
        navigation: {
            prevEl: '.related .arrow-left',
            nextEl: '.related .arrow-right',
        },
        breakpoints: {
            0: {
                enabled: false,
            },
            992: {
                enabled: true,
                slidesPerView: 3,
            }
        }
    })
})